// extracted by mini-css-extract-plugin
module.exports =  {"sidebar-trigger":"DyUsDNR","sidebarTrigger":"DyUsDNR"};